subscribeToQuery